module.exports = __webpack_public_path__ + "static/media/valentin_tsatskin.49e7676c.png";